import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const DescriptionCard = () => {
  const roles = [
    { role: "Viewer", description: "View Dashboard" },
    { role: "Verifier", description: "Verify Applications" },
    { role: "Approver", description: "Approve Applications" },
    { role: "Supervisor", description: "Supervisor" },
    { role: "Management", description: "Assign Supervisor" },
    { role: "Head", description: "Head of Department" },
    { role: "Admin", description: "Portal Administrator" },
  ];

  return (
    <div className="flex justify-end m-auto w-[95%] xl:w-[80%] max-w-[70rem] ">
      {/* <Box className="w-[40%] mt-4 mb-6">
        <Card variant="outlined">
          <CardContent>
            <Typography color="text.primary" gutterBottom>
              Role Descriptions
            </Typography>
            <ul style={{ paddingLeft: "20px" }}>
              {roles.map((roleObj) => (
                <li key={roleObj.role}>
                  <Typography variant="body1" component="span">
                    <strong>{roleObj.role}: </strong>
                    {roleObj.description}
                  </Typography>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      </Box> */}
    </div>
  );
};

export default DescriptionCard;
